import {
  ACCESS_TOKEN,
  DEVICE_TOKEN,
  REFRESH_TOKEN,
  REFRESH_TOKEN_EXPIRED_AT
} from './key';

export const getDeviceToken = () => {
  return localStorage.getItem(DEVICE_TOKEN);
};
export const saveDeviceToken = (deviceToken: string) => {
  localStorage.setItem(DEVICE_TOKEN, deviceToken);
};
export const removeDeviceToken = () => {
  localStorage.removeItem(DEVICE_TOKEN);
};

export const getAccessToken = () => {
  return localStorage.getItem(ACCESS_TOKEN);
};
export const saveAccessToken = (accessToken: string) => {
  localStorage.setItem(ACCESS_TOKEN, accessToken);
};
export const removeAccessToken = () => {
  localStorage.removeItem(ACCESS_TOKEN);
};
export const getRefreshToken = () => {
  return localStorage.getItem(REFRESH_TOKEN);
};
export const saveRefreshToken = (refreshToken: string | null | undefined) => {
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
  }
};
export const removeRefreshToken = () => {
  localStorage.removeItem(REFRESH_TOKEN);
};
export const getRefreshTokenExpiredAt = () => {
  return localStorage.getItem(REFRESH_TOKEN_EXPIRED_AT);
};
export const saveRefreshTokenExpiredAt = (
  refreshTokenExpiredAt: string | null | undefined
) => {
  if (refreshTokenExpiredAt) {
    localStorage.setItem(REFRESH_TOKEN_EXPIRED_AT, refreshTokenExpiredAt);
  }
};
export const removeRefreshTokenExpiredAt = () => {
  localStorage.removeItem(REFRESH_TOKEN_EXPIRED_AT);
};
